import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

interface MetricCardSkeletonProps {
  showMetadataIcon?: boolean;
}

const MetricCardSkeleton: React.FC<MetricCardSkeletonProps> = ({
  showMetadataIcon = true,
}) => (
  <div className="relative overflow-hidden group hover:shadow-lg transition-all border rounded-xl bg-white">
    <div className="p-4">
      {/* Top row: icon + optional metadata icon */}
      <div className="flex items-start justify-between mb-1">
        {/* Icon container */}
        <div className="rounded-lg bg-gresham-slate/10 p-2 group-hover:bg-gresham-slate/20 transition-colors">
          <Skeleton circle height={30} width={32} />
        </div>

        {/* Metadata icon */}
        {showMetadataIcon && (
          <div
            className="
              inline-flex h-6 w-6 items-center justify-center rounded
            "
          >
            <Skeleton circle height={20} width={20} />
          </div>
        )}
      </div>

      {/* Text content: name, value, unit descriptor */}
      <div className="space-y-0.5">
        {/* Name */}
        <h3 className="text-sm font-medium text-muted-foreground">
          <Skeleton width="60%" height={14} />
        </h3>

        {/* Value */}
        <div className="flex items-baseline mt-1">
          <span className="text-3xl font-semibold tracking-tight">
            <Skeleton width={120} height={32} />
          </span>
        </div>

        {/* Unit descriptor */}
        <p className="text-xs text-muted-foreground leading-tight mt-1">
          <Skeleton width="80%" height={12} />
        </p>
      </div>
    </div>
  </div>
);

export default MetricCardSkeleton;
